import gql from "graphql-tag";

export const GET_ARABIC_REGIONS_NAMES = gql`
  subscription GET_ARABIC_REGIONS_NAMES {
    covid_arabic_regions {
      region
    }
  }
`;
